// not derived from ScheduleDetailMode since there might be more subroutes than modes in the future
export const scheduleSubRoutes = {
  create: 'create',
  edit: 'edit',
  copy: 'copy',
} as const;
